import { useState, useEffect } from 'react';
import Layout from "../../components/Layout";
import { api, listarTudo } from "../../services/api";

export default function XmlImporter() {
  const [activeTab, setActiveTab] = useState('xml');
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);
  const [xmlData, setXmlData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [fornecedores, setFornecedores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [searchTermFornecedor, setSearchTermFornecedor] = useState('');
  const [searchTermProduto, setSearchTermProduto] = useState('');
  const [unidades, setUnidades] = useState([]);
  const [showFornecedorModal, setShowFornecedorModal] = useState(false);
  const [produtoModalIndex, setProdutoModalIndex] = useState(null);
  const [editingItemIndex, setEditingItemIndex] = useState(-1);
  const [showProdutoModalForManual, setShowProdutoModalForManual] = useState(false);
  const [showParcelasModal, setShowParcelasModal] = useState(false);
  const [notasRegistradas, setNotasRegistradas] = useState([]);
  const [loadingNotas, setLoadingNotas] = useState(false);
  const [filtroNotas, setFiltroNotas] = useState('');
  const [notaDetalhe, setNotaDetalhe] = useState(null);
  const [cancelandoNota, setCancelandoNota] = useState(false);
  const [pendingReimp, setPendingReimp] = useState(null); // payload aguardando confirmação de reimportação
  const [fornecedorStatus, setFornecedorStatus] = useState(null); // 'novo' | 'existente' | 'dados_alterados'
  const [fornecedorAlteracoes, setFornecedorAlteracoes] = useState({});
  const [confirmarAtualizacao, setConfirmarAtualizacao] = useState(false);
  const [tipoOperacao, setTipoOperacao] = useState(null); // 'entrada' | 'saida'
  const [confirmarDestinatario, setConfirmarDestinatario] = useState(false);
  const [confirmarEmitente, setConfirmarEmitente] = useState(false);
  const [clienteStatus, setClienteStatus] = useState(null);
  const [clienteAlteracoes, setClienteAlteracoes] = useState({});
  const [confirmarAtualizacaoCliente, setConfirmarAtualizacaoCliente] = useState(false);

  const [manualData, setManualData] = useState({
    fornecedor: '',
    fornecedor_id: '',
    numero_nf: '',
    serie: '1',
    chave_acesso: '',
    data_emissao: '',
    data_entrada_saida: '',
    data_vencimento: '',
    valor_total: 0,
    valor_frete: 0,
    valor_seguro: 0,
    valor_desconto: 0,
    valor_outras: 0,
    observacoes: '',
    forma_pagamento: 'prazo',
    tipo_parcela: 'fixa',
    numero_parcelas: 1,
    parcelas: [],
    itens: []
  });

  const [manualItemForm, setManualItemForm] = useState({
    codigo: '',
    descricao: '',
    quantidade: 1,
    unidade: 'UN',
    valor_unitario: 0,
    codigo_barras: '',
    ncm: '',
    cfop: '5102',
    icms_valor: 0,
    ipi_valor: 0,
    pis_valor: 0,
    cofins_valor: 0,
    produto_id: null
  });

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR');
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const toNumber = (v, defaultValue = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : defaultValue;
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ text, type });
    setTimeout(() => setMessage({ text: '', type: '' }), 5000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [fornecedoresRes, unidadesRes, produtosRes] = await Promise.all([
          listarTudo('/financeiro/fornecedores/'),
          listarTudo('/almoxarifado/unidades-medida/'),
          listarTudo('/almoxarifado/itens-estoque/')
        ]);

        const fornecedoresData = fornecedoresRes.data;
        const unidadesData = unidadesRes.data;
        const produtosData = produtosRes.data;

        setFornecedores(Array.isArray(fornecedoresData) ? fornecedoresData : fornecedoresData.results || []);
        setUnidades(Array.isArray(unidadesData) ? unidadesData : unidadesData.results || []);
        setProdutos(Array.isArray(produtosData) ? produtosData : produtosData.results || []);
      } catch (err) {
        console.error('Erro ao carregar dados:', err);
        showMessage('Erro ao carregar dados iniciais', 'error');
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!manualData.data_emissao) {
      setManualData(prev => ({
        ...prev,
        data_emissao: new Date().toISOString().split('T')[0],
        data_entrada_saida: new Date().toISOString().split('T')[0]
      }));
    }
  }, []);

  const fetchNotasRegistradas = async () => {
    setLoadingNotas(true);
    try {
      const res = await listarTudo('/financeiro/notas-fiscais/');
      const data = res.data;
      setNotasRegistradas(Array.isArray(data) ? data : data.results || []);
    } catch (err) {
      console.error('Erro ao carregar notas:', err);
      showMessage('Erro ao carregar notas registradas', 'error');
    } finally {
      setLoadingNotas(false);
    }
  };

  const cancelarNota = async (nota) => {
    if (!window.confirm(
      `Cancelar NF-e ${nota.numero_nf}/${nota.serie}?\n\n` +
      `Isso irá:\n• Reverter todas as movimentações de estoque\n• Cancelar as contas a pagar geradas\n\n` +
      `Esta ação não pode ser desfeita.`
    )) return;

    setCancelandoNota(true);
    try {
      await api.post(`/financeiro/notas-fiscais/${nota.id}/cancelar/`);
      showMessage(`NF-e ${nota.numero_nf} cancelada com sucesso.`, 'success');
      setNotaDetalhe(prev => prev?.id === nota.id ? { ...prev, status_fiscal: 'cancelada' } : prev);
      setNotasRegistradas(prev =>
        prev.map(n => n.id === nota.id ? { ...n, status_fiscal: 'cancelada' } : n)
      );
    } catch (err) {
      const msg = err.response?.data?.detail || 'Erro ao cancelar nota.';
      showMessage(msg, 'error');
    } finally {
      setCancelandoNota(false);
    }
  };

  // Calcula valor total da nota baseado nos itens e adicionais
  useEffect(() => {
    const totalItens = manualData.itens.reduce((sum, item) => sum + (item.valor_total || 0), 0);
    const total = totalItens + manualData.valor_frete + manualData.valor_seguro + manualData.valor_outras - manualData.valor_desconto;
    console.log("Recalculando total:", { totalItens, total });
    setManualData(prev => ({ ...prev, valor_total: total }));
  }, [manualData.itens, manualData.valor_frete, manualData.valor_seguro, manualData.valor_desconto, manualData.valor_outras]);

  // Gera parcelas automaticamente quando mudar número de parcelas ou data de vencimento
  useEffect(() => {
    if (manualData.tipo_parcela === 'fixa' && manualData.numero_parcelas > 0 && manualData.valor_total > 0) {
      const valorParcela = manualData.valor_total / manualData.numero_parcelas;
      const parcelas = [];
      let dataVencimento = manualData.data_vencimento ? new Date(manualData.data_vencimento) : new Date(manualData.data_emissao);
      
      for (let i = 0; i < manualData.numero_parcelas; i++) {
        const dataParcela = new Date(dataVencimento);
        if (i > 0) {
          dataParcela.setMonth(dataParcela.getMonth() + i);
        }
        parcelas.push({
          numero: i + 1,
          valor: valorParcela,
          data_vencimento: dataParcela.toISOString().split('T')[0],
          status: 'pendente'
        });
      }
      setManualData(prev => ({ ...prev, parcelas }));
    }
  }, [manualData.numero_parcelas, manualData.valor_total, manualData.data_vencimento, manualData.tipo_parcela, manualData.data_emissao]);

  const getUnidadeId = (sigla) => {
    if (!sigla) return null;
    const unidade = unidades.find(u => u.sigla?.toUpperCase() === sigla.toUpperCase());
    return unidade ? unidade.id : null;
  };

  const getOrCreateUnidade = async (sigla) => {
    let unidade = unidades.find(u => u.sigla?.toUpperCase() === sigla.toUpperCase());
    if (unidade) return unidade.id;

    try {
      const res = await api.post('/almoxarifado/unidades-medida/', {
        sigla: sigla.toUpperCase(),
        descricao: sigla.toUpperCase()
      });

      const nova = res.data;
      setUnidades(prev => [...prev, nova]);
      return nova.id;
    } catch (err) {
      console.error("Erro ao criar unidade:", err);
    }
    return null;
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.name.toLowerCase().endsWith('.xml')) {
      setFile(selectedFile);
      setShowPreview(false);
      setXmlData(null);
      setFornecedorStatus(null);
      setFornecedorAlteracoes({});
      setConfirmarAtualizacao(false);
      setTipoOperacao(null);
      setConfirmarDestinatario(false);
      setConfirmarEmitente(false);
      setClienteStatus(null);
      setClienteAlteracoes({});
      setConfirmarAtualizacaoCliente(false);
      showMessage('Arquivo selecionado com sucesso!', 'success');
    } else {
      setFile(null);
      showMessage('Por favor, selecione um arquivo XML válido.', 'error');
    }
  };

  const handlePreviewXml = async (e) => {
    e.preventDefault();
    if (!file) return;

    const formData = new FormData();
    formData.append("xml_file", file);

    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const res = await api.post('/financeiro/notas-fiscais/preview/', formData);

      const data = res.data;

      if (data.dados) {
        const dados = data.dados;

        const itensNormalizados = (dados.itens || []).map((item) => ({
          codigo_interno: item.codigo_interno || item.codigo || '',
          descricao_produto: item.descricao_produto || item.descricao || '',
          quantidade: toNumber(item.quantidade),
          valor_unitario: toNumber(item.valor_unitario),
          unidade: item.unidade ? String(item.unidade).toUpperCase() : 'UN',
          ncm: item.ncm || '',
          cfop: item.cfop || '',
          codigo_barras: item.codigo_barras || '',
          valor_total: toNumber(item.valor_total, toNumber(item.quantidade) * toNumber(item.valor_unitario)),
          associado: false,
          produto_id: null
        }));

        setXmlData({
          ...dados,
          itens: itensNormalizados,
          fornecedor_id: dados.fornecedor?.id || null
        });
        // Usa o status enviado pelo backend; se ainda não veio (deploy pendente),
        // infere: ID presente → já cadastrado, só CNPJ → será criado
        const statusInferido = dados.fornecedor?.id
          ? 'existente'
          : (dados.fornecedor?.cnpj ? 'novo' : null);
        setFornecedorStatus(dados.fornecedor_status || statusInferido);
        setFornecedorAlteracoes(dados.fornecedor_alteracoes || {});
        setConfirmarAtualizacao(false);
        setTipoOperacao(null);
        setConfirmarDestinatario(false);
        setConfirmarEmitente(false);
        setClienteStatus(dados.cliente_status || null);
        setClienteAlteracoes(dados.cliente_alteracoes || {});
        setConfirmarAtualizacaoCliente(false);
        setShowPreview(true);
        showMessage('XML processado com sucesso! Revise os dados abaixo.', 'success');
      } else {
        showMessage(data.detail || data.error || 'Erro ao processar XML', 'error');
      }
    } catch (err) {
      console.error(err);
      const data = err.response?.data;
      showMessage(data?.detail || data?.error || 'Erro de conexão com o servidor.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveNotaFiscal = async () => {
    if (!xmlData || !xmlData.itens || xmlData.itens.length === 0) {
      showMessage('Não há dados para salvar.', 'error');
      return;
    }

    if (!tipoOperacao) {
      showMessage('Selecione o tipo de operação: Entrada ou Saída.', 'error');
      return;
    }

    const itensNaoAssociados = xmlData.itens.filter(i => !i.produto_id);
    if (itensNaoAssociados.length > 0) {
      showMessage(`Associe todos os produtos antes de salvar. ${itensNaoAssociados.length} item(ns) pendente(s).`, 'error');
      return;
    }

    // Bloqueia apenas se não há ID de fornecedor E não há CNPJ no XML para auto-criação
    const temFornecedor = xmlData.fornecedor_id || xmlData.fornecedor?.id || xmlData.fornecedor?.cnpj;
    if (!temFornecedor) {
      showMessage('Selecione um fornecedor antes de salvar.', 'error');
      return;
    }

    const isSaida = tipoOperacao === 'saida';

    // Alerta de destinatário divergente (ENTRADA) — bloqueia se não confirmado
    if (!isSaida && xmlData.destinatario_alerta && !confirmarDestinatario) {
      showMessage('O destinatário da NF é diferente desta fazenda. Confirme antes de salvar.', 'error');
      return;
    }

    // Alerta de emitente divergente (SAÍDA) — bloqueia se não confirmado
    if (isSaida && xmlData.emitente_alerta && !confirmarEmitente) {
      showMessage('O emitente da NF é diferente desta fazenda. Confirme antes de salvar.', 'error');
      return;
    }

    setLoading(true);

    const itensFormatados = xmlData.itens.map(i => ({
      produto: i.produto_id,
      codigo_interno: i.codigo_interno,
      descricao_produto: i.descricao_produto,
      quantidade: i.quantidade,
      valor_unitario: i.valor_unitario,
      valor_total: i.valor_total,
      unidade: i.unidade || 'UN',
      ncm: i.ncm || '00000000',
      codigo_barras: i.codigo_barras || null,
      cfop: i.cfop || '5102',
      icms_valor: 0,
      ipi_valor: 0,
      pis_valor: 0,
      cofins_valor: 0
    }));
    
    const payload = {
      numero_nf: xmlData.numero_nf,
      serie: xmlData.serie || "1",
      tipo_nf: tipoOperacao,
      data_emissao: xmlData.data_emissao,
      data_entrada_saida: xmlData.data_emissao,
      fornecedor_id: xmlData.fornecedor_id || xmlData.fornecedor?.id || null,
      fornecedor: xmlData.fornecedor || null,
      chave_acesso: xmlData.chave_acesso || null,
      valor_total_nf: xmlData.itens.reduce((sum, i) => sum + i.valor_total, 0),
      valor_total_produtos: xmlData.itens.reduce((sum, i) => sum + i.valor_total, 0),
      confirmar_atualizacao_fornecedor: confirmarAtualizacao,
      ...(isSaida && {
        cliente_id: xmlData.cliente_id || null,
        cliente: xmlData.destinatario || null,
        confirmar_atualizacao_cliente: confirmarAtualizacaoCliente,
      }),
      itens: itensFormatados
    };

    const executarSalvamento = async (payloadFinal) => {
      const res = await api.post('/financeiro/notas-fiscais/', payloadFinal);
      const extras = [res.data?.fornecedor_mensagem, res.data?.cliente_mensagem].filter(Boolean).join(' ');
      const mensagem = extras
        ? `Nota fiscal salva com sucesso! ${extras}.`
        : 'Nota fiscal salva com sucesso!';
      showMessage(mensagem, 'success');
      setPendingReimp(null);
      setXmlData(null);
      setShowPreview(false);
      setFile(null);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
    };

    try {
      await executarSalvamento(payload);
    } catch (err) {
      console.error(err);
      const errorData = err.response?.data;

      if (errorData?.reimportacao_permitida) {
        // Mostra banner de confirmação inline — não usa window.confirm
        setPendingReimp({ ...payload, confirmar_reimportacao: true });
      } else if (errorData) {
        showMessage(`Erro ao salvar: ${errorData.detail || errorData.message || JSON.stringify(errorData)}`, 'error');
      } else {
        showMessage('Falha ao salvar no servidor.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const confirmarReimp = async () => {
    if (!pendingReimp) return;
    setLoading(true);
    try {
      await api.post('/financeiro/notas-fiscais/', pendingReimp);
      showMessage('Nota fiscal reimportada com sucesso!', 'success');
      setPendingReimp(null);
      setXmlData(null);
      setShowPreview(false);
      setFile(null);
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
    } catch (err2) {
      const msg2 = err2.response?.data?.detail || 'Erro ao reimportar nota.';
      showMessage(`Erro ao reimportar: ${msg2}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const associarProduto = (itemIndex, produtoId) => {
    const produto = produtos.find(p => p.id === produtoId);
    if (!produto) return;

    const updated = [...xmlData.itens];
    updated[itemIndex] = {
      ...updated[itemIndex],
      associado: true,
      produto_id: produtoId,
      codigo_interno: produto.codigo_interno || produto.codigo || updated[itemIndex].codigo_interno,
      descricao_produto: produto.nome,
      valor_unitario: produto.preco_custo || updated[itemIndex].valor_unitario,
      valor_total: (produto.preco_custo || updated[itemIndex].valor_unitario) * updated[itemIndex].quantidade
    };
    
    setXmlData({ ...xmlData, itens: updated });
    showMessage(`Produto "${produto.nome}" associado com sucesso!`, 'success');
  };

  const associarProdutoManual = (produtoId) => {
    const produto = produtos.find(p => p.id === produtoId);
    if (!produto) return;

    setManualItemForm({
      codigo: produto.codigo,
      descricao: produto.nome,
      unidade: produto.unidade_medida?.sigla || 'UN',
      valor_unitario: produto.preco_custo || 0,
      codigo_barras: produto.codigo_barras || '',
      ncm: produto.ncm || '',
      cfop: manualItemForm.cfop || '5102',
      quantidade: 1,
      icms_valor: 0,
      ipi_valor: 0,
      pis_valor: 0,
      cofins_valor: 0,
      produto_id: produtoId
    });
    
    showMessage(`Produto "${produto.nome}" selecionado! Edite a quantidade e valor se necessário.`, 'success');
    setShowProdutoModalForManual(false);
  };

  const updateXmlItem = (index, field, value) => {
    const updated = [...xmlData.itens];
    updated[index][field] = value;
    
    if (field === 'quantidade' || field === 'valor_unitario') {
      updated[index].valor_total = updated[index].quantidade * updated[index].valor_unitario;
    }
    
    setXmlData({ ...xmlData, itens: updated });
  };

  const criarProdutoAPartirDoItem = async (item, index) => {
    if (!item.descricao_produto) {
      showMessage("Descrição do produto é obrigatória", "error");
      return;
    }

    try {
      const unidadeId = await getOrCreateUnidade(item.unidade);
      if (!unidadeId) {
        showMessage("Erro ao definir unidade de medida", "error");
        return;
      }

      const payload = {
        nome: item.descricao_produto,
        codigo: item.codigo_interno,
        preco_custo: item.valor_unitario,
        unidade_medida_id: unidadeId,
        codigo_barras: item.codigo_barras || null,
        ncm: item.ncm || null
      };

      const res = await api.post('/almoxarifado/itens-estoque/', payload);
      const data = res.data;

      // Atualiza lista de produtos e associa diretamente sem depender do estado atualizado
      setProdutos(prev => [...prev, data]);
      const updated = [...xmlData.itens];
      updated[index] = {
        ...updated[index],
        associado: true,
        produto_id: data.id,
        codigo_interno: data.codigo_interno || data.codigo || updated[index].codigo_interno,
        descricao_produto: data.nome,
        valor_unitario: data.preco_custo || updated[index].valor_unitario,
        valor_total: (data.preco_custo || updated[index].valor_unitario) * updated[index].quantidade,
      };
      setXmlData({ ...xmlData, itens: updated });
      showMessage('Produto criado e associado com sucesso!', 'success');
    } catch (err) {
      console.error(err);
      const data = err.response?.data;
      showMessage(data?.detail || data?.message || "Erro ao criar produto", "error");
    }
  };

  const removerItem = (index) => {
    if (!window.confirm('Tem certeza que deseja remover este item?')) return;
    const updated = xmlData.itens.filter((_, i) => i !== index);
    setXmlData({ ...xmlData, itens: updated });
  };

  const resetManualItemForm = () => {
    setManualItemForm({
      codigo: '',
      descricao: '',
      quantidade: 1,
      unidade: 'UN',
      valor_unitario: 0,
      codigo_barras: '',
      ncm: '',
      cfop: '5102',
      icms_valor: 0,
      ipi_valor: 0,
      pis_valor: 0,
      cofins_valor: 0,
      produto_id: null
    });
    setEditingItemIndex(null);
  };

  const addOrUpdateManualItem = () => {
    // 1. VALIDAÇÕES
    if (!manualItemForm.descricao && !manualItemForm.codigo) {
      showMessage('Preencha pelo menos o código ou descrição do item.', 'error');
      return;
    }

    if (manualItemForm.ncm && !/^\d{8}$/.test(manualItemForm.ncm)) {
      showMessage('NCM deve conter 8 dígitos numéricos', 'error');
      return;
    }

    if (manualItemForm.cfop && !/^\d{4}$/.test(manualItemForm.cfop)) {
      showMessage('CFOP deve conter 4 dígitos numéricos', 'error');
      return;
    }

    const quantidade = toNumber(manualItemForm.quantidade, 0);
    const valor_unitario = toNumber(manualItemForm.valor_unitario, 0);
    
    if (quantidade <= 0) {
      showMessage('Quantidade deve ser maior que zero.', 'error');
      return;
    }
    
    if (valor_unitario <= 0) {
      showMessage('Valor unitário deve ser maior que zero.', 'error');
      return;
    }

    // 2. CALCULA O VALOR TOTAL DO ITEM
    const valor_total = quantidade * valor_unitario;

    // 3. CRIA O OBJETO DO ITEM
    const itemToSave = {
      codigo: manualItemForm.codigo,
      descricao: manualItemForm.descricao,
      quantidade: quantidade,
      unidade: manualItemForm.unidade || 'UN',
      valor_unitario: valor_unitario,
      valor_total: valor_total,
      codigo_barras: manualItemForm.codigo_barras,
      ncm: manualItemForm.ncm,
      cfop: manualItemForm.cfop,
      icms_valor: manualItemForm.icms_valor,
      ipi_valor: manualItemForm.ipi_valor,
      pis_valor: manualItemForm.pis_valor,
      cofins_valor: manualItemForm.cofins_valor,
      produto_id: manualItemForm.produto_id
    };

    // 4. ADICIONA OU ATUALIZA O ITEM NA LISTA
    const itens = [...manualData.itens];
    
    if (editingItemIndex >= 0) {
      // Modo edição: substitui o item existente
      itens[editingItemIndex] = itemToSave;
      showMessage('Item atualizado com sucesso!', 'success');
    } else {
      // Modo adição: insere novo item
      itens.push(itemToSave);
      showMessage('Item adicionado com sucesso!', 'success');
    }
    
    // 5. ATUALIZA O ESTADO COM A NOVA LISTA DE ITENS
    // O total será recalculado automaticamente pelo useEffect
    setManualData(prev => ({ 
      ...prev, 
      itens: itens
    }));
    
    // 6. LIMPA O FORMULÁRIO PARA O PRÓXIMO ITEM
    resetManualItemForm();
  };

  const editManualItem = (idx) => {
    console.log("✏️ Editando item no índice:", idx);
    const item = manualData.itens[idx];
    setManualItemForm({
      codigo: item.codigo || '',
      descricao: item.descricao || '',
      quantidade: item.quantidade || 0,
      unidade: item.unidade || 'UN',
      valor_unitario: item.valor_unitario || 0,
      codigo_barras: item.codigo_barras || '',
      ncm: item.ncm || '',
      cfop: item.cfop || '5102',
      icms_valor: item.icms_valor || 0,
      ipi_valor: item.ipi_valor || 0,
      pis_valor: item.pis_valor || 0,
      cofins_valor: item.cofins_valor || 0,
      produto_id: item.produto_id || null
    });
    setEditingItemIndex(idx);
    console.log("✅ Modo edição ativado, editingItemIndex agora é:", idx);
  };

  const removeManualItem = (idx) => {
    if (!window.confirm('Remover este item?')) return;
    const itens = manualData.itens.filter((_, i) => i !== idx);
    setManualData(prev => ({ ...prev, itens }));
    resetManualItemForm();
  };

  const updateParcela = (index, field, value) => {
    const updatedParcelas = [...manualData.parcelas];
    updatedParcelas[index][field] = value;
    setManualData(prev => ({ ...prev, parcelas: updatedParcelas }));
  };

  const addParcela = () => {
    const novaParcela = {
      numero: manualData.parcelas.length + 1,
      valor: 0,
      data_vencimento: '',
      status: 'pendente'
    };
    setManualData(prev => ({ ...prev, parcelas: [...prev.parcelas, novaParcela] }));
  };

  const removeParcela = (index) => {
    const updatedParcelas = manualData.parcelas.filter((_, i) => i !== index);
    // Reorganiza os números das parcelas
    updatedParcelas.forEach((p, i) => p.numero = i + 1);
    setManualData(prev => ({ ...prev, parcelas: updatedParcelas }));
  };

  const saveManualNota = async () => {
    if (!manualData.fornecedor_id) {
      showMessage('Selecione um fornecedor.', 'error');
      return;
    }
    if (!manualData.numero_nf) {
      showMessage('Informe o número da nota fiscal.', 'error');
      return;
    }
    if (!/^\d+$/.test(manualData.numero_nf)) {
      showMessage('Número da NF deve ser numérico', 'error');
      return;
    }
    if (!manualData.itens || manualData.itens.length === 0) {
      showMessage('Adicione pelo menos um item à nota fiscal.', 'error');
      return;
    }

    setLoading(true);

    const payload = {
      numero_nf: manualData.numero_nf,
      serie: manualData.serie || '1',
      tipo_nf: 'entrada',
      data_emissao: manualData.data_emissao,
      data_entrada_saida: manualData.data_entrada_saida || manualData.data_emissao,
      fornecedor_id: manualData.fornecedor_id,
      chave_acesso: manualData.chave_acesso || null,
      observacoes: manualData.observacoes,
      valor_total_nf: manualData.valor_total,
      valor_total_produtos: manualData.itens.reduce((sum, item) => sum + item.valor_total, 0),
      valor_frete: manualData.valor_frete,
      valor_seguro: manualData.valor_seguro,
      valor_desconto: manualData.valor_desconto,
      itens: manualData.itens.map(item => ({
        produto: item.produto_id || null,
        codigo_interno: item.codigo,
        descricao_produto: item.descricao,
        quantidade: item.quantidade,
        valor_unitario: item.valor_unitario,
        valor_total: item.valor_total,
        unidade: item.unidade,
        ncm: item.ncm || '00000000',
        codigo_barras: item.codigo_barras || null,
        cfop: item.cfop || '5102',
        icms_valor: item.icms_valor || 0,
        ipi_valor: item.ipi_valor || 0,
        pis_valor: item.pis_valor || 0,
        cofins_valor: item.cofins_valor || 0
      })),
      contas_pagar: manualData.parcelas.map(parcela => ({
        documento: `${manualData.numero_nf}-${parcela.numero}`,
        data_vencimento: parcela.data_vencimento,
        valor_total: parcela.valor,
        status: 'pendente',
        observacoes: `Parcela ${parcela.numero} de ${manualData.parcelas.length} da NF ${manualData.numero_nf}`
      }))
    };

    try {
      await api.post('/financeiro/notas-fiscais/manual/', payload);

      showMessage('Nota fiscal e contas a pagar salvas com sucesso!', 'success');
      setManualData({
        fornecedor: '',
        fornecedor_id: '',
        numero_nf: '',
        serie: '1',
        chave_acesso: '',
        data_emissao: '',
        data_entrada_saida: '',
        data_vencimento: '',
        valor_total: 0,
        valor_frete: 0,
        valor_seguro: 0,
        valor_desconto: 0,
        valor_outras: 0,
        observacoes: '',
        forma_pagamento: 'prazo',
        tipo_parcela: 'fixa',
        numero_parcelas: 1,
        parcelas: [],
        itens: [],
      });
      resetManualItemForm();
      setActiveTab('xml');
    } catch (err) {
      console.error(err);
      const errorData = err.response?.data;
      if (errorData) {
        showMessage(
          errorData.detail ||
          errorData.message ||
          JSON.stringify(errorData.errors || errorData),
          'error'
        );
      } else {
        showMessage('Erro de conexão com o servidor.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
            Entrada de Notas Fiscais
          </h1>
          <p className="text-gray-600">
            Importe arquivos XML modelo 55 ou cadastre notas manualmente
          </p>
        </div>

        <div className="flex gap-2 mb-6 border-b">
          <button
            onClick={() => {
              setActiveTab('xml');
              setShowPreview(false);
            }}
            className={`px-6 py-3 font-medium transition-colors ${
              activeTab === 'xml'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            📄 Importar XML
          </button>
          <button
            onClick={() => {
              setActiveTab('manual');
              setShowPreview(false);
            }}
            className={`px-6 py-3 font-medium transition-colors ${
              activeTab === 'manual'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            ✍️ Cadastro Manual
          </button>
          <button
            onClick={() => {
              setActiveTab('lista');
              setShowPreview(false);
              fetchNotasRegistradas();
            }}
            className={`px-6 py-3 font-medium transition-colors ${
              activeTab === 'lista'
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            📋 Notas Registradas
          </button>
        </div>

        {message.text && (
          <div className={`mb-4 p-3 rounded-lg ${
            message.type === 'success' ? 'bg-green-100 text-green-700 border border-green-200' : 
            message.type === 'warning' ? 'bg-yellow-100 text-yellow-700 border border-yellow-200' :
            'bg-red-100 text-red-700 border border-red-200'
          }`}>
            {message.text}
          </div>
        )}

        {/* Aba XML (mantida igual) */}
        {activeTab === 'xml' && (
          <div className="space-y-6">
            {!showPreview ? (
              <form onSubmit={handlePreviewXml} className="bg-white rounded-lg shadow p-6">
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2 font-semibold">
                    Selecione o arquivo XML (Modelo 55)
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-blue-500 transition-colors">
                    <input
                      type="file"
                      accept=".xml"
                      onChange={handleFileChange}
                      className="block w-full text-sm text-gray-500
                        file:mr-4 file:py-2 file:px-4
                        file:rounded-md file:border-0
                        file:text-sm file:font-semibold
                        file:bg-blue-50 file:text-blue-700
                        hover:file:bg-blue-100"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      Arraste e solte ou clique para selecionar
                    </p>
                  </div>
                </div>

                {file && (
                  <p className="text-sm text-gray-600 mb-4">
                    Arquivo selecionado: <span className="font-medium">{file.name}</span>
                  </p>
                )}

                <button
                  type="submit"
                  disabled={!file || loading}
                  className={`w-full py-3 rounded-lg text-white font-semibold transition-colors ${
                    !file || loading
                      ? 'bg-gray-400 cursor-not-allowed'
                      : 'bg-blue-600 hover:bg-blue-700'
                  }`}
                >
                  {loading ? 'Processando...' : 'Visualizar XML'}
                </button>
              </form>
            ) : (
              <div className="bg-white rounded-lg shadow p-6 space-y-4">
                <div className="flex justify-between items-center">
                  <h2 className="text-xl font-bold text-gray-800">Pré-visualização da Nota Fiscal</h2>
                  <button
                    onClick={() => {
                      setShowPreview(false);
                      setXmlData(null);
                      setFile(null);
                      setFornecedorStatus(null);
                      setFornecedorAlteracoes({});
                      setConfirmarAtualizacao(false);
                      setTipoOperacao(null);
                      setConfirmarDestinatario(false);
                      setConfirmarEmitente(false);
                      setClienteStatus(null);
                      setClienteAlteracoes({});
                      setConfirmarAtualizacaoCliente(false);
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    ✕ Voltar
                  </button>
                </div>
                
                {pendingReimp && (
                  <div className="bg-yellow-50 border border-yellow-400 rounded-lg p-4">
                    <p className="text-sm font-semibold text-yellow-800 mb-1">
                      Esta nota já foi registrada e está cancelada.
                    </p>
                    <p className="text-sm text-yellow-700 mb-3">
                      Deseja reimportá-la? A entrada cancelada será substituída pela nova importação.
                      Confirme apenas se precisar corrigir quantidades ou dados.
                    </p>
                    <div className="flex gap-3">
                      <button
                        onClick={confirmarReimp}
                        disabled={loading}
                        className="px-4 py-2 bg-yellow-600 text-white rounded-lg text-sm font-semibold hover:bg-yellow-700 disabled:bg-gray-400 transition-colors"
                      >
                        {loading ? 'Reimportando...' : 'Sim, reimportar'}
                      </button>
                      <button
                        onClick={() => setPendingReimp(null)}
                        className="px-4 py-2 bg-white border border-yellow-400 text-yellow-800 rounded-lg text-sm font-semibold hover:bg-yellow-50 transition-colors"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}

                <div className="bg-blue-50 p-3 rounded-lg">
                  <p className="text-sm text-blue-800">
                    ⚠️ Revise os dados abaixo antes de salvar. Você pode editar os itens e associar produtos existentes.
                  </p>
                </div>

                {/* Toggle ENTRADA / SAÍDA */}
                <div>
                  <p className="text-xs text-gray-500 mb-1 font-medium">Tipo de operação</p>
                  <div className="flex gap-1 p-1 bg-gray-100 rounded-lg w-fit">
                    <button
                      type="button"
                      onClick={() => setTipoOperacao('entrada')}
                      className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-colors ${
                        tipoOperacao === 'entrada'
                          ? 'bg-white shadow text-blue-700'
                          : 'text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      📥 Entrada
                    </button>
                    <button
                      type="button"
                      onClick={() => setTipoOperacao('saida')}
                      className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-colors ${
                        tipoOperacao === 'saida'
                          ? 'bg-white shadow text-orange-700'
                          : 'text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      📤 Saída
                    </button>
                  </div>
                </div>

                {/* Alerta de destinatário divergente (ENTRADA) */}
                {tipoOperacao === 'entrada' && xmlData?.destinatario_alerta && (
                  <div className="bg-orange-50 border border-orange-400 p-3 rounded-lg">
                    <p className="text-sm text-orange-800 font-semibold mb-1">
                      ⚠️ O destinatário desta NF não é esta fazenda
                    </p>
                    <p className="text-sm text-orange-700 mb-2">
                      Destinatário no XML:{' '}
                      <span className="font-medium">{xmlData.destinatario_alerta.nome}</span>
                      {xmlData.destinatario_alerta.cnpj && ` (CNPJ: ${xmlData.destinatario_alerta.cnpj})`}
                    </p>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={confirmarDestinatario}
                        onChange={e => setConfirmarDestinatario(e.target.checked)}
                        className="h-4 w-4 accent-orange-600"
                      />
                      <span className="text-sm text-orange-800 font-medium">
                        Confirmar entrada mesmo assim
                      </span>
                    </label>
                  </div>
                )}

                {/* Alerta de emitente divergente (SAÍDA) */}
                {tipoOperacao === 'saida' && xmlData?.emitente_alerta && (
                  <div className="bg-orange-50 border border-orange-400 p-3 rounded-lg">
                    <p className="text-sm text-orange-800 font-semibold mb-1">
                      ⚠️ O emitente desta NF não é esta fazenda
                    </p>
                    <p className="text-sm text-orange-700 mb-2">
                      Emitente no XML:{' '}
                      <span className="font-medium">{xmlData.emitente_alerta.nome}</span>
                      {xmlData.emitente_alerta.cnpj && ` (CNPJ: ${xmlData.emitente_alerta.cnpj})`}
                    </p>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={confirmarEmitente}
                        onChange={e => setConfirmarEmitente(e.target.checked)}
                        className="h-4 w-4 accent-orange-600"
                      />
                      <span className="text-sm text-orange-800 font-medium">
                        Confirmar saída mesmo assim
                      </span>
                    </label>
                  </div>
                )}

                {/* Banners de cliente (SAÍDA) */}
                {tipoOperacao === 'saida' && clienteStatus === 'novo' && (
                  <div className="bg-green-50 border border-green-300 p-3 rounded-lg">
                    <p className="text-sm text-green-800 font-medium">
                      ✅ Cliente não encontrado na base — será cadastrado automaticamente ao salvar.
                    </p>
                  </div>
                )}
                {tipoOperacao === 'saida' && clienteStatus === 'existente' && (
                  <div className="bg-gray-50 border border-gray-300 p-3 rounded-lg">
                    <p className="text-sm text-gray-600 font-medium">
                      ✓ Cliente já cadastrado — nenhuma alteração de dados detectada.
                    </p>
                  </div>
                )}
                {tipoOperacao === 'saida' && clienteStatus === 'dados_alterados' && (
                  <div className="bg-yellow-50 border border-yellow-400 p-3 rounded-lg">
                    <p className="text-sm text-yellow-800 font-semibold mb-2">
                      ⚠️ Dados do cliente foram alterados no XML em relação ao cadastro atual:
                    </p>
                    <ul className="text-sm text-yellow-700 mb-3 space-y-1">
                      {Object.values(clienteAlteracoes).map(({ label, atual, novo }) => (
                        <li key={label}>
                          <span className="font-medium">{label}:</span>{' '}
                          <span className="line-through text-gray-500">{atual || '(vazio)'}</span>
                          {' → '}
                          <span className="font-medium">{novo}</span>
                        </li>
                      ))}
                    </ul>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={confirmarAtualizacaoCliente}
                        onChange={e => setConfirmarAtualizacaoCliente(e.target.checked)}
                        className="h-4 w-4 accent-yellow-600"
                      />
                      <span className="text-sm text-yellow-800 font-medium">
                        Atualizar dados do cliente ao salvar
                      </span>
                    </label>
                  </div>
                )}

                {/* Banner: fornecedor já cadastrado, sem alterações */}
                {tipoOperacao !== 'saida' && fornecedorStatus === 'existente' && (
                  <div className="bg-gray-50 border border-gray-300 p-3 rounded-lg">
                    <p className="text-sm text-gray-600 font-medium">
                      ✓ Fornecedor já cadastrado — nenhuma alteração de dados detectada.
                    </p>
                  </div>
                )}

                {/* Banner: fornecedor novo */}
                {tipoOperacao !== 'saida' && fornecedorStatus === 'novo' && (
                  <div className="bg-green-50 border border-green-300 p-3 rounded-lg">
                    <p className="text-sm text-green-800 font-medium">
                      ✅ Fornecedor não encontrado na base — será cadastrado automaticamente ao salvar.
                    </p>
                  </div>
                )}

                {/* Banner: dados do fornecedor mudaram */}
                {tipoOperacao !== 'saida' && fornecedorStatus === 'dados_alterados' && (
                  <div className="bg-yellow-50 border border-yellow-400 p-3 rounded-lg">
                    <p className="text-sm text-yellow-800 font-semibold mb-2">
                      ⚠️ Dados do fornecedor foram alterados no XML em relação ao cadastro atual:
                    </p>
                    <ul className="text-sm text-yellow-700 mb-3 space-y-1">
                      {Object.values(fornecedorAlteracoes).map(({ label, atual, novo }) => (
                        <li key={label}>
                          <span className="font-medium">{label}:</span>{' '}
                          <span className="line-through text-gray-500">{atual || '(vazio)'}</span>
                          {' → '}
                          <span className="font-medium">{novo}</span>
                        </li>
                      ))}
                    </ul>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={confirmarAtualizacao}
                        onChange={e => setConfirmarAtualizacao(e.target.checked)}
                        className="h-4 w-4 accent-yellow-600"
                      />
                      <span className="text-sm text-yellow-800 font-medium">
                        Atualizar dados do fornecedor ao salvar
                      </span>
                    </label>
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
                  <div>
                    <p className="text-sm text-gray-600">{tipoOperacao === 'saida' ? 'Emitente' : 'Fornecedor'}</p>
                    <div className="flex gap-2 items-center">
                      <div className="flex-1">
                        <p className="font-semibold">{xmlData?.fornecedor?.nome || xmlData?.fornecedor?.razao_social || '—'}</p>
                        {tipoOperacao !== 'saida' && fornecedorStatus === 'novo' && (
                          <span className="inline-block mt-1 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">
                            Será cadastrado automaticamente
                          </span>
                        )}
                        {tipoOperacao !== 'saida' && fornecedorStatus === 'existente' && (
                          <span className="inline-block mt-1 text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full font-medium">
                            Já cadastrado
                          </span>
                        )}
                        {tipoOperacao !== 'saida' && fornecedorStatus === 'dados_alterados' && (
                          <span className="inline-block mt-1 text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full font-medium">
                            ⚠ Dados diferentes no XML
                          </span>
                        )}
                        {tipoOperacao === 'saida' && (
                          <span className="inline-block mt-1 text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-medium">
                            Emitente da NF
                          </span>
                        )}
                      </div>
                      {tipoOperacao !== 'saida' && (
                        <button
                          onClick={() => setShowFornecedorModal(true)}
                          className="text-blue-600 hover:text-blue-800 text-sm"
                        >
                          Alterar
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Cliente — só para SAÍDA */}
                  {tipoOperacao === 'saida' && (
                    <div>
                      <p className="text-sm text-gray-600">Cliente (Destinatário)</p>
                      <div className="flex-1">
                        <p className="font-semibold">{xmlData?.destinatario?.nome || '—'}</p>
                        {clienteStatus === 'novo' && (
                          <span className="inline-block mt-1 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-medium">
                            Será cadastrado automaticamente
                          </span>
                        )}
                        {clienteStatus === 'existente' && (
                          <span className="inline-block mt-1 text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full font-medium">
                            Já cadastrado
                          </span>
                        )}
                        {clienteStatus === 'dados_alterados' && (
                          <span className="inline-block mt-1 text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full font-medium">
                            ⚠ Dados diferentes no XML
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div>
                    <p className="text-sm text-gray-600">Número da NF</p>
                    <p className="font-semibold">{xmlData?.numero_nf || '—'}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Data de Emissão</p>
                    <p className="font-semibold">{formatDate(xmlData?.data_emissao)}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600">Série</p>
                    <p className="font-semibold">{xmlData?.serie || '—'}</p>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-sm text-gray-600">Chave de Acesso</p>
                    <p className="font-mono text-sm break-all">{xmlData?.chave_acesso || '—'}</p>
                  </div>
                </div>

                {xmlData?.itens && xmlData.itens.length > 0 && (
                  <div>
                    <h3 className="text-lg font-semibold mb-3">Itens da Nota Fiscal</h3>
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="border p-2 text-left">Código</th>
                            <th className="border p-2 text-left">Descrição</th>
                            <th className="border p-2 text-right">Qtd</th>
                            <th className="border p-2 text-center">Unid</th>
                            <th className="border p-2 text-right">Valor Unit.</th>
                            <th className="border p-2 text-right">Total</th>
                            <th className="border p-2 text-center">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {xmlData.itens.map((item, idx) => (
                            <tr key={idx} className="hover:bg-gray-50">
                              <td className="border p-2">
                                <input
                                  type="text"
                                  value={item.codigo_interno}
                                  onChange={(e) => updateXmlItem(idx, 'codigo_interno', e.target.value)}
                                  className="w-full border rounded px-1 py-1"
                                />
                              </td>
                              <td className="border p-2">
                                <input
                                  type="text"
                                  value={item.descricao_produto}
                                  onChange={(e) => updateXmlItem(idx, 'descricao_produto', e.target.value)}
                                  className="w-full border rounded px-1 py-1"
                                />
                              </td>
                              <td className="border p-2">
                                <input
                                  type="number"
                                  step="0.01"
                                  value={item.quantidade}
                                  onChange={(e) => updateXmlItem(idx, 'quantidade', parseFloat(e.target.value))}
                                  className="w-24 border rounded px-1 py-1 text-right"
                                />
                              </td>
                              <td className="border p-2">
                                <select
                                  value={item.unidade}
                                  onChange={(e) => updateXmlItem(idx, 'unidade', e.target.value)}
                                  className="border rounded px-2 py-1 w-20"
                                >
                                  <option value="UN">UN</option>
                                  <option value="CX">CX</option>
                                  <option value="KG">KG</option>
                                  <option value="M">M</option>
                                  <option value="PC">PC</option>
                                </select>
                              </td>
                              <td className="border p-2">
                                <input
                                  type="number"
                                  step="0.01"
                                  value={item.valor_unitario}
                                  onChange={(e) => updateXmlItem(idx, 'valor_unitario', parseFloat(e.target.value))}
                                  className="w-24 border rounded px-1 py-1 text-right"
                                />
                              </td>
                              <td className="border p-2 text-right font-semibold">
                                R$ {item.valor_total.toFixed(2)}
                              </td>
                              <td className="border p-2">
                                <div className="flex gap-1 justify-center flex-wrap">
                                  {!item.associado ? (
                                    <button
                                      type="button"
                                      onClick={() => setProdutoModalIndex(idx)}
                                      className="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded text-xs"
                                    >
                                      🔗 Associar
                                    </button>
                                  ) : (
                                    <span className="text-xs text-green-600 font-semibold">✓ Associado</span>
                                  )}

                                  <button
                                    onClick={() => criarProdutoAPartirDoItem(item, idx)}
                                    className="bg-green-600 hover:bg-green-700 text-white px-2 py-1 rounded text-xs"
                                  >
                                    ➕ Criar
                                  </button>

                                  <button
                                    onClick={() => removerItem(idx)}
                                    className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-xs"
                                  >
                                    🗑️
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot className="bg-gray-50 font-bold">
                          <tr>
                            <td colSpan="5" className="border p-2 text-right">
                              Total Geral:
                            </td>
                            <td className="border p-2 text-right">
                              R$ {xmlData.itens.reduce((sum, i) => sum + i.valor_total, 0).toFixed(2)}
                            </td>
                            <td className="border p-2"></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div className="mt-6 flex gap-3">
                      <button
                        onClick={handleSaveNotaFiscal}
                        disabled={loading}
                        className="flex-1 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold disabled:bg-gray-400 transition-colors"
                      >
                        {loading ? 'Salvando...' : '✅ Confirmar e Salvar Nota Fiscal'}
                      </button>
                      <button
                        onClick={() => {
                          setShowPreview(false);
                          setXmlData(null);
                          setFile(null);
                        }}
                        className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-semibold transition-colors"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Aba Manual - Versão Completa com Financeiro */}
        {activeTab === 'manual' && (
          <div className="bg-white rounded-lg shadow p-6 space-y-6">
            <h2 className="text-xl font-bold text-gray-800">Cadastro Manual de Nota Fiscal</h2>
            
            {/* Dados da Nota Fiscal */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Fornecedor *
                </label>
                <div className="flex gap-2">
                  <input
                    type="text"
                    value={manualData.fornecedor}
                    readOnly
                    placeholder="Clique em buscar para selecionar"
                    className="flex-1 border rounded-lg p-2 bg-gray-50"
                  />
                  <button
                    type="button"
                    onClick={() => setShowFornecedorModal(true)}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    🔍 Buscar
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Número da NF *
                </label>
                <input
                  type="text"
                  value={manualData.numero_nf}
                  onChange={(e) => setManualData({ ...manualData, numero_nf: e.target.value.replace(/\D/g, '') })}
                  className="w-full border rounded-lg p-2"
                  placeholder="Apenas números"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Série
                </label>
                <input
                  type="text"
                  value={manualData.serie}
                  onChange={(e) => setManualData({ ...manualData, serie: e.target.value })}
                  className="w-full border rounded-lg p-2"
                  placeholder="1"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Data de Emissão
                </label>
                <input
                  type="date"
                  value={manualData.data_emissao}
                  onChange={(e) => setManualData({ ...manualData, data_emissao: e.target.value })}
                  className="w-full border rounded-lg p-2"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Data de Entrada/Saída
                </label>
                <input
                  type="date"
                  value={manualData.data_entrada_saida}
                  onChange={(e) => setManualData({ ...manualData, data_entrada_saida: e.target.value })}
                  className="w-full border rounded-lg p-2"
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Chave de Acesso (opcional)
                </label>
                <input
                  type="text"
                  value={manualData.chave_acesso}
                  onChange={(e) => setManualData({ ...manualData, chave_acesso: e.target.value.replace(/\D/g, '').slice(0, 44) })}
                  className="w-full border rounded-lg p-2 font-mono text-sm"
                  placeholder="44 dígitos da chave de acesso"
                  maxLength="44"
                />
              </div>

              <div className="md:col-span-4">
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Observações
                </label>
                <textarea
                  value={manualData.observacoes}
                  onChange={(e) => setManualData({ ...manualData, observacoes: e.target.value })}
                  rows="2"
                  className="w-full border rounded-lg p-2"
                  placeholder="Observações adicionais..."
                />
              </div>
            </div>

            {/* Valores da Nota Fiscal */}
            <div className="border-t pt-4">
              <h3 className="text-lg font-semibold mb-3">Valores da Nota Fiscal</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Frete</label>
                  <input
                    type="number"
                    step="0.01"
                    value={manualData.valor_frete}
                    onChange={(e) => setManualData({ ...manualData, valor_frete: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded-lg p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Seguro</label>
                  <input
                    type="number"
                    step="0.01"
                    value={manualData.valor_seguro}
                    onChange={(e) => setManualData({ ...manualData, valor_seguro: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded-lg p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Desconto</label>
                  <input
                    type="number"
                    step="0.01"
                    value={manualData.valor_desconto}
                    onChange={(e) => setManualData({ ...manualData, valor_desconto: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded-lg p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Outras Despesas</label>
                  <input
                    type="number"
                    step="0.01"
                    value={manualData.valor_outras}
                    onChange={(e) => setManualData({ ...manualData, valor_outras: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded-lg p-2"
                  />
                </div>
                <div className="bg-blue-50 p-2 rounded-lg">
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Total da NF</label>
                  <p className="text-xl font-bold text-blue-700">{formatCurrency(manualData.valor_total)}</p>
                </div>
              </div>
            </div>

            {/* Configuração de Parcelas */}
            <div className="border-t pt-4">
              <h3 className="text-lg font-semibold mb-3">Configuração de Pagamento</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Forma de Pagamento</label>
                  <select
                    value={manualData.forma_pagamento}
                    onChange={(e) => setManualData({ ...manualData, forma_pagamento: e.target.value })}
                    className="w-full border rounded-lg p-2"
                  >
                    <option value="prazo">Prazo</option>
                    <option value="vista">À Vista</option>
                  </select>
                </div>
                
                {manualData.forma_pagamento === 'prazo' && (
                  <>
                    <div>
                      <label className="block text-sm text-gray-600 mb-1">Tipo de Parcela</label>
                      <select
                        value={manualData.tipo_parcela}
                        onChange={(e) => setManualData({ ...manualData, tipo_parcela: e.target.value })}
                        className="w-full border rounded-lg p-2"
                      >
                        <option value="fixa">Parcelas Fixas</option>
                        <option value="personalizada">Personalizar Parcelas</option>
                      </select>
                    </div>
                    
                    {manualData.tipo_parcela === 'fixa' && (
                      <>
                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Número de Parcelas</label>
                          <input
                            type="number"
                            min="1"
                            max="24"
                            value={manualData.numero_parcelas}
                            onChange={(e) => setManualData({ ...manualData, numero_parcelas: parseInt(e.target.value) || 1 })}
                            className="w-full border rounded-lg p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-sm text-gray-600 mb-1">Data da Primeira Parcela</label>
                          <input
                            type="date"
                            value={manualData.data_vencimento}
                            onChange={(e) => setManualData({ ...manualData, data_vencimento: e.target.value })}
                            className="w-full border rounded-lg p-2"
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>

              {manualData.forma_pagamento === 'prazo' && manualData.tipo_parcela === 'personalizada' && (
                <div className="mt-4">
                  <button
                    type="button"
                    onClick={() => setShowParcelasModal(true)}
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                  >
                    📋 Gerenciar Parcelas ({manualData.parcelas.length} parcelas)
                  </button>
                </div>
              )}

              {manualData.forma_pagamento === 'vista' && (
                <div className="mt-2 p-3 bg-green-50 rounded-lg">
                  <p className="text-sm text-green-800">
                    Pagamento à vista. Será gerada uma única parcela no valor total da nota.
                  </p>
                </div>
              )}
            </div>

            {/* Resumo da Nota */}
            <div className="p-4 bg-blue-50 rounded-lg">
              <h3 className="font-semibold mb-2">Resumo da Nota</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <p><span className="text-gray-600">Status:</span> <span className="font-semibold">Pendente</span></p>
                <p><span className="text-gray-600">Total Itens:</span> <span className="font-semibold">{manualData.itens.length}</span></p>
                <p><span className="text-gray-600">Total Produtos:</span> <span className="font-semibold">{formatCurrency(manualData.itens.reduce((sum, i) => sum + i.valor_total, 0))}</span></p>
                <p><span className="text-gray-600">Total NF:</span> <span className="font-semibold text-lg">{formatCurrency(manualData.valor_total)}</span></p>
              </div>
            </div>

            {/* Itens da Nota - Formulário Simplificado */}
            <div className="border-t pt-4">
              <h3 className="text-lg font-semibold mb-3">
                {editingItemIndex >= 0 ? '✏️ Editar Item' : '➕ Adicionar Item'}
              </h3>
              
              {/* Primeira linha: campos principais */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Código</label>
                  <input
                    type="text"
                    value={manualItemForm.codigo}
                    onChange={(e) => setManualItemForm({ ...manualItemForm, codigo: e.target.value })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="Código"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="block text-xs text-gray-600 mb-1">Descrição *</label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      value={manualItemForm.descricao}
                      onChange={(e) => setManualItemForm({ ...manualItemForm, descricao: e.target.value })}
                      className="flex-1 border rounded p-2 text-sm"
                      placeholder="Descrição do produto"
                    />
                    <button
                      type="button"
                      onClick={() => setShowProdutoModalForManual(true)}
                      className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded text-sm whitespace-nowrap"
                      title="Buscar produto existente"
                    >
                      🔍 Buscar
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-xs text-gray-600 mb-1">Qtd *</label>
                  <input
                    type="number"
                    value={manualItemForm.quantidade}
                    min="0.01"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, quantidade: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                  />
                </div>
              </div>

              {/* Segunda linha: unidade, valor, NCM, CFOP */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Unidade</label>
                  <select
                    value={manualItemForm.unidade}
                    onChange={(e) => setManualItemForm({ ...manualItemForm, unidade: e.target.value })}
                    className="w-full border rounded p-2 text-sm"
                  >
                    <option value="UN">UN</option>
                    <option value="CX">CX</option>
                    <option value="KG">KG</option>
                    <option value="M">M</option>
                    <option value="PC">PC</option>
                    <option value="DZ">DZ</option>
                    <option value="PACK">PACK</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs text-gray-600 mb-1">Valor Unit. *</label>
                  <input
                    type="number"
                    value={manualItemForm.valor_unitario}
                    min="0.01"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, valor_unitario: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                  />
                </div>

                <div>
                  <label className="block text-xs text-gray-600 mb-1">NCM</label>
                  <input
                    type="text"
                    value={manualItemForm.ncm}
                    onChange={(e) => setManualItemForm({ ...manualItemForm, ncm: e.target.value.replace(/\D/g, '').slice(0, 8) })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="8 dígitos"
                    maxLength="8"
                  />
                </div>

                <div>
                  <label className="block text-xs text-gray-600 mb-1">CFOP</label>
                  <input
                    type="text"
                    value={manualItemForm.cfop}
                    onChange={(e) => setManualItemForm({ ...manualItemForm, cfop: e.target.value.replace(/\D/g, '').slice(0, 4) })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="5102"
                    maxLength="4"
                  />
                </div>
              </div>

              {/* Terceira linha: impostos */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
                <div>
                  <label className="block text-xs text-gray-600 mb-1">ICMS</label>
                  <input
                    type="number"
                    value={manualItemForm.icms_valor}
                    min="0"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, icms_valor: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="0,00"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">IPI</label>
                  <input
                    type="number"
                    value={manualItemForm.ipi_valor}
                    min="0"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, ipi_valor: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="0,00"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">PIS</label>
                  <input
                    type="number"
                    value={manualItemForm.pis_valor}
                    min="0"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, pis_valor: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="0,00"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">COFINS</label>
                  <input
                    type="number"
                    value={manualItemForm.cofins_valor}
                    min="0"
                    step="0.01"
                    onChange={(e) => setManualItemForm({ ...manualItemForm, cofins_valor: parseFloat(e.target.value) || 0 })}
                    className="w-full border rounded p-2 text-sm"
                    placeholder="0,00"
                  />
                </div>
              </div>

              {/* Quarta linha: código de barras (se tiver) */}
              {manualItemForm.codigo_barras && (
                <div className="mb-3">
                  <label className="block text-xs text-gray-600 mb-1">Código de Barras</label>
                  <input
                    type="text"
                    value={manualItemForm.codigo_barras}
                    onChange={(e) => setManualItemForm({ ...manualItemForm, codigo_barras: e.target.value })}
                    className="w-full border rounded p-2 text-sm font-mono"
                    placeholder="Código de barras do produto"
                  />
                </div>
              )}

              {/* BOTÕES - Em uma linha separada e bem visível */}
              <div className="flex gap-3 mt-4 pt-3 border-t">
                <button
                  type="button"
                  onClick={addOrUpdateManualItem}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors shadow-md text-base"
                >
                  {editingItemIndex >= 0 ? '✏️ ATUALIZAR ITEM' : '➕ ADICIONAR ITEM À NOTA'}
                </button>
                {editingItemIndex >= 0 && (
                  <button
                    type="button"
                    onClick={resetManualItemForm}
                    className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-bold rounded-lg transition-colors shadow-md text-base"
                  >
                    ❌ CANCELAR EDIÇÃO
                  </button>
                )}
              </div>
            </div>

            {/* Lista de Itens */}
            {manualData.itens.length > 0 && (
              <div>
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-lg font-semibold">Itens da Nota</h3>
                  <div className="text-sm text-gray-600">
                    Total: <span className="font-bold text-lg">{formatCurrency(manualData.valor_total)}</span>
                  </div>
                </div>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border p-2 text-left">Código</th>
                        <th className="border p-2 text-left">Descrição</th>
                        <th className="border p-2 text-right">Qtd</th>
                        <th className="border p-2 text-center">Unid</th>
                        <th className="border p-2 text-right">Valor Unit.</th>
                        <th className="border p-2 text-right">Total</th>
                        <th className="border p-2 text-center">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {manualData.itens.map((item, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                          <td className="border p-2">{item.codigo || '—'}</td>
                          <td className="border p-2">
                            {item.descricao}
                            {item.produto_id && <span className="ml-2 text-xs text-green-600">✓ vinculado</span>}
                            </td>
                          <td className="border p-2 text-right">{item.quantidade.toFixed(2)}</td>
                          <td className="border p-2 text-center">{item.unidade}</td>
                          <td className="border p-2 text-right">{formatCurrency(item.valor_unitario)}</td>
                          <td className="border p-2 text-right font-semibold">{formatCurrency(item.valor_total)}</td>
                          <td className="border p-2">
                            <div className="flex gap-1 justify-center">
                              <button
                                onClick={() => editManualItem(idx)}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-xs transition-colors"
                                title="Editar"
                              >
                                ✏️
                              </button>
                              <button
                                onClick={() => removeManualItem(idx)}
                                className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded text-xs transition-colors"
                                title="Remover"
                              >
                                🗑️
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="bg-gray-50 font-bold">
                      <tr>
                        <td colSpan="5" className="border p-2 text-right">Total Geral:</td>
                        <td className="border p-2 text-right">{formatCurrency(manualData.valor_total)}</td>
                        <td className="border p-2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            )}

            {/* Botões de Ação */}
            <div className="flex gap-3 pt-4 border-t">
              <button
                onClick={saveManualNota}
                disabled={loading}
                className="flex-1 bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 disabled:bg-gray-400 transition-colors"
              >
                {loading ? 'Salvando...' : '💾 Salvar Nota Fiscal e Contas a Pagar'}
              </button>
              <button
                onClick={() => {
                  if (window.confirm('Cancelar cadastro manual e limpar formulário?')) {
                    setManualData({
                      fornecedor: '',
                      fornecedor_id: '',
                      numero_nf: '',
                      serie: '1',
                      chave_acesso: '',
                      data_emissao: '',
                      data_entrada_saida: '',
                      data_vencimento: '',
                      valor_total: 0,
                      valor_frete: 0,
                      valor_seguro: 0,
                      valor_desconto: 0,
                      valor_outras: 0,
                      observacoes: '',
                      forma_pagamento: 'prazo',
                      tipo_parcela: 'fixa',
                      numero_parcelas: 1,
                      parcelas: [],
                      itens: [],
                    });
                    resetManualItemForm();
                  }
                }}
                className="px-6 py-3 bg-gray-600 text-white rounded-lg font-semibold hover:bg-gray-700 transition-colors"
              >
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Aba Notas Registradas */}
        {activeTab === 'lista' && (
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
              <h2 className="text-xl font-bold text-gray-800">Notas Fiscais Registradas</h2>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Filtrar por nº, fornecedor ou chave..."
                  value={filtroNotas}
                  onChange={e => setFiltroNotas(e.target.value)}
                  className="border rounded-lg px-3 py-2 text-sm w-64"
                />
                <button
                  onClick={fetchNotasRegistradas}
                  disabled={loadingNotas}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 disabled:bg-gray-400 transition-colors"
                >
                  {loadingNotas ? 'Carregando...' : '↺ Atualizar'}
                </button>
              </div>
            </div>

            {loadingNotas ? (
              <div className="text-center py-12 text-gray-500">Carregando notas...</div>
            ) : notasRegistradas.length === 0 ? (
              <div className="text-center py-12 text-gray-400">Nenhuma nota fiscal registrada.</div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b bg-gray-50">
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Nº / Série</th>
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Fornecedor</th>
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Tipo</th>
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Emissão</th>
                      <th className="text-right px-3 py-2 font-semibold text-gray-600">Valor Total</th>
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Status</th>
                      <th className="text-left px-3 py-2 font-semibold text-gray-600">Chave de Acesso</th>
                      <th className="px-3 py-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {notasRegistradas
                      .filter(n => {
                        if (!filtroNotas) return true;
                        const f = filtroNotas.toLowerCase();
                        return (
                          n.numero_nf?.toLowerCase().includes(f) ||
                          n.emitente_nome?.toLowerCase().includes(f) ||
                          n.chave_acesso?.toLowerCase().includes(f)
                        );
                      })
                      .map(nota => (
                        <tr key={nota.id} className="border-b hover:bg-gray-50 transition-colors">
                          <td className="px-3 py-2 font-mono">
                            {nota.numero_nf} / {nota.serie}
                          </td>
                          <td className="px-3 py-2 max-w-xs truncate" title={nota.emitente_nome}>
                            {nota.emitente_nome || '—'}
                          </td>
                          <td className="px-3 py-2">
                            <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${
                              nota.tipo_nf === 'entrada'
                                ? 'bg-green-100 text-green-700'
                                : 'bg-orange-100 text-orange-700'
                            }`}>
                              {nota.tipo_nf === 'entrada' ? 'Entrada' : 'Saída'}
                            </span>
                          </td>
                          <td className="px-3 py-2">{formatDate(nota.data_emissao)}</td>
                          <td className="px-3 py-2 text-right font-medium">
                            {formatCurrency(nota.valor_total_nf)}
                          </td>
                          <td className="px-3 py-2">
                            <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${
                              nota.status_fiscal === 'cancelada'
                                ? 'bg-red-100 text-red-700'
                                : nota.status_fiscal === 'processada'
                                ? 'bg-blue-100 text-blue-700'
                                : 'bg-yellow-100 text-yellow-700'
                            }`}>
                              {nota.status_fiscal === 'cancelada' ? 'Cancelada'
                                : nota.status_fiscal === 'processada' ? 'Processada'
                                : 'Emitida'}
                            </span>
                          </td>
                          <td className="px-3 py-2 font-mono text-xs text-gray-400 max-w-xs truncate" title={nota.chave_acesso}>
                            {nota.chave_acesso ? `...${nota.chave_acesso.slice(-12)}` : '—'}
                          </td>
                          <td className="px-3 py-2">
                            <button
                              onClick={() => setNotaDetalhe(nota)}
                              className="px-3 py-1 bg-blue-600 text-white text-xs rounded hover:bg-blue-700 transition-colors"
                            >
                              Ver
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <p className="text-xs text-gray-400 mt-3">
                  {notasRegistradas.filter(n => {
                    if (!filtroNotas) return true;
                    const f = filtroNotas.toLowerCase();
                    return n.numero_nf?.toLowerCase().includes(f) || n.emitente_nome?.toLowerCase().includes(f) || n.chave_acesso?.toLowerCase().includes(f);
                  }).length} nota(s) exibida(s)
                </p>
              </div>
            )}
          </div>
        )}

        {notaDetalhe && (
          <NotaDetalheModal
            nota={notaDetalhe}
            cancelandoNota={cancelandoNota}
            onCancelar={() => cancelarNota(notaDetalhe)}
            onClose={() => setNotaDetalhe(null)}
            formatDate={formatDate}
            formatCurrency={formatCurrency}
          />
        )}

        {showFornecedorModal && (
          <FornecedorModal
            searchTerm={searchTermFornecedor}
            setSearchTerm={setSearchTermFornecedor}
            fornecedores={fornecedores}
            activeTab={activeTab}
            xmlData={xmlData}
            setXmlData={setXmlData}
            manualData={manualData}
            setManualData={setManualData}
            onClose={() => { setShowFornecedorModal(false); setSearchTermFornecedor(''); }}
          />
        )}
        {showParcelasModal && (
          <ParcelasModal
            manualData={manualData}
            updateParcela={updateParcela}
            addParcela={addParcela}
            removeParcela={removeParcela}
            formatCurrency={formatCurrency}
            onClose={() => setShowParcelasModal(false)}
          />
        )}
        {produtoModalIndex !== null && (
          <ProdutoModal
            produtos={produtos}
            searchTerm={searchTermProduto}
            setSearchTerm={setSearchTermProduto}
            onSelect={(produtoId) => associarProduto(produtoModalIndex, produtoId)}
            onClose={() => { setProdutoModalIndex(null); setSearchTermProduto(''); }}
          />
        )}
        {showProdutoModalForManual && (
          <ProdutoModal
            produtos={produtos}
            searchTerm={searchTermProduto}
            setSearchTerm={setSearchTermProduto}
            onSelect={(produtoId) => associarProdutoManual(produtoId)}
            onClose={() => { setShowProdutoModalForManual(false); setSearchTermProduto(''); }}
          />
        )}
      </div>
    </Layout>
  );
}

function NotaDetalheModal({ nota, cancelandoNota, onCancelar, onClose, formatDate, formatCurrency }) {
  const isCancelada = nota.status_fiscal === 'cancelada';
  const itens = nota.itens || [];

  const statusLabel = { cancelada: 'Cancelada', processada: 'Processada', emitida: 'Emitida' };
  const statusCor = {
    cancelada: 'bg-red-100 text-red-700',
    processada: 'bg-blue-100 text-blue-700',
    emitida: 'bg-yellow-100 text-yellow-700',
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl my-6">
        {/* Cabeçalho */}
        <div className="flex items-center justify-between p-5 border-b">
          <div>
            <h2 className="text-xl font-bold text-gray-800">
              NF-e {nota.numero_nf}/{nota.serie}
            </h2>
            <p className="text-sm text-gray-500 mt-0.5">
              {nota.tipo_nf === 'entrada' ? 'Entrada (Compra)' : 'Saída (Venda)'}
              {' · '}
              <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${statusCor[nota.status_fiscal] || statusCor.emitida}`}>
                {statusLabel[nota.status_fiscal] || nota.status_fiscal}
              </span>
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>

        {/* Dados gerais */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-5 border-b bg-gray-50 text-sm">
          <div>
            <span className="text-gray-500 block text-xs">Fornecedor / Emitente</span>
            <span className="font-semibold">{nota.emitente_nome || '—'}</span>
          </div>
          <div>
            <span className="text-gray-500 block text-xs">Data de Emissão</span>
            <span className="font-semibold">{formatDate(nota.data_emissao)}</span>
          </div>
          <div>
            <span className="text-gray-500 block text-xs">Data de Entrada/Saída</span>
            <span className="font-semibold">{formatDate(nota.data_entrada_saida) || '—'}</span>
          </div>
          <div>
            <span className="text-gray-500 block text-xs">Valor Total</span>
            <span className="font-bold text-green-700">{formatCurrency(nota.valor_total_nf)}</span>
          </div>
          {nota.chave_acesso && (
            <div className="col-span-2 md:col-span-4">
              <span className="text-gray-500 block text-xs">Chave de Acesso</span>
              <span className="font-mono text-xs text-gray-600 break-all">{nota.chave_acesso}</span>
            </div>
          )}
          {(nota.valor_frete > 0 || nota.valor_desconto > 0 || nota.valor_seguro > 0) && (
            <div className="col-span-2 md:col-span-4 flex gap-6 text-xs text-gray-600">
              {nota.valor_frete > 0 && <span>Frete: {formatCurrency(nota.valor_frete)}</span>}
              {nota.valor_seguro > 0 && <span>Seguro: {formatCurrency(nota.valor_seguro)}</span>}
              {nota.valor_desconto > 0 && <span>Desconto: -{formatCurrency(nota.valor_desconto)}</span>}
            </div>
          )}
        </div>

        {/* Itens */}
        <div className="p-5">
          <h3 className="font-semibold text-gray-700 mb-3">Itens ({itens.length})</h3>
          {itens.length === 0 ? (
            <p className="text-sm text-gray-400">Nenhum item registrado.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b bg-gray-50">
                    <th className="text-left px-2 py-2 text-xs text-gray-600">Código</th>
                    <th className="text-left px-2 py-2 text-xs text-gray-600">Descrição</th>
                    <th className="text-left px-2 py-2 text-xs text-gray-600">NCM</th>
                    <th className="text-right px-2 py-2 text-xs text-gray-600">Qtd</th>
                    <th className="text-left px-2 py-2 text-xs text-gray-600">Un.</th>
                    <th className="text-right px-2 py-2 text-xs text-gray-600">Vlr Unit.</th>
                    <th className="text-right px-2 py-2 text-xs text-gray-600">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {itens.map((item, idx) => (
                    <tr key={item.id || idx} className="border-b hover:bg-gray-50">
                      <td className="px-2 py-2 font-mono text-xs text-gray-500">{item.codigo_interno || item.codigo_fornecedor || '—'}</td>
                      <td className="px-2 py-2">{item.descricao_produto}</td>
                      <td className="px-2 py-2 font-mono text-xs">{item.ncm || '—'}</td>
                      <td className="px-2 py-2 text-right">{Number(item.quantidade).toLocaleString('pt-BR', { maximumFractionDigits: 4 })}</td>
                      <td className="px-2 py-2">{item.unidade}</td>
                      <td className="px-2 py-2 text-right">{formatCurrency(item.valor_unitario)}</td>
                      <td className="px-2 py-2 text-right font-medium">{formatCurrency(item.valor_total)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="border-t-2">
                    <td colSpan={6} className="px-2 py-2 text-right font-semibold text-gray-700">Total dos Produtos</td>
                    <td className="px-2 py-2 text-right font-bold text-green-700">
                      {formatCurrency(nota.valor_total_produtos)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>

        {/* Rodapé */}
        <div className="flex justify-between items-center p-5 border-t bg-gray-50">
          <div className="text-xs text-gray-400">
            {isCancelada
              ? 'Esta nota está cancelada. O estoque e as contas a pagar já foram revertidos.'
              : 'Notas salvas não podem ser editadas. Para desfazer, use o cancelamento.'}
          </div>
          <div className="flex gap-3">
            {!isCancelada && (
              <button
                onClick={onCancelar}
                disabled={cancelandoNota}
                className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm hover:bg-red-700 disabled:bg-gray-400 transition-colors font-semibold"
              >
                {cancelandoNota ? 'Cancelando...' : 'Cancelar Nota'}
              </button>
            )}
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300 transition-colors font-semibold"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function FornecedorModal({ searchTerm, setSearchTerm, fornecedores, activeTab, xmlData, setXmlData, manualData, setManualData, onClose }) {
  const filtrados = fornecedores.filter(f =>
    f.razao_social?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.cnpj?.includes(searchTerm)
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">Selecionar Fornecedor</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <input
          type="text"
          placeholder="Buscar fornecedor por nome ou CNPJ..."
          className="w-full p-2 border rounded mb-4"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="space-y-2 max-h-96 overflow-y-auto">
          {filtrados.map(fornecedor => (
            <div
              key={fornecedor.id}
              className="p-3 border rounded hover:bg-gray-50 cursor-pointer transition-colors"
              onClick={() => {
                if (activeTab === 'xml' && xmlData) {
                  setXmlData({ ...xmlData, fornecedor, fornecedor_id: fornecedor.id });
                } else {
                  setManualData({
                    ...manualData,
                    fornecedor: fornecedor.razao_social,
                    fornecedor_id: fornecedor.id
                  });
                }
                onClose();
              }}
            >
              <div className="font-semibold">{fornecedor.razao_social}</div>
              <div className="text-sm text-gray-600">CNPJ: {fornecedor.cnpj}</div>
            </div>
          ))}

          {filtrados.length === 0 && (
            <div className="text-center text-gray-500 py-4">
              Nenhum fornecedor encontrado
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function ParcelasModal({ manualData, updateParcela, addParcela, removeParcela, formatCurrency, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">Gerenciar Parcelas</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <div className="mb-4 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Total da Nota:</strong> {formatCurrency(manualData.valor_total)}<br />
            <strong>Total das Parcelas:</strong> {formatCurrency(manualData.parcelas.reduce((sum, p) => sum + p.valor, 0))}
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2 text-center">Nº</th>
                <th className="border p-2 text-left">Data Vencimento</th>
                <th className="border p-2 text-right">Valor</th>
                <th className="border p-2 text-center">Status</th>
                <th className="border p-2 text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              {manualData.parcelas.map((parcela, idx) => (
                <tr key={idx}>
                  <td className="border p-2 text-center">{parcela.numero}</td>
                  <td className="border p-2">
                    <input
                      type="date"
                      value={parcela.data_vencimento}
                      onChange={(e) => updateParcela(idx, 'data_vencimento', e.target.value)}
                      className="w-full border rounded p-1"
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="number"
                      step="0.01"
                      value={parcela.valor}
                      onChange={(e) => updateParcela(idx, 'valor', parseFloat(e.target.value) || 0)}
                      className="w-full border rounded p-1 text-right"
                    />
                  </td>
                  <td className="border p-2 text-center">
                    <select
                      value={parcela.status}
                      onChange={(e) => updateParcela(idx, 'status', e.target.value)}
                      className="border rounded p-1"
                    >
                      <option value="pendente">Pendente</option>
                      <option value="pago">Pago</option>
                      <option value="atrasado">Atrasado</option>
                    </select>
                  </td>
                  <td className="border p-2 text-center">
                    <button
                      onClick={() => removeParcela(idx)}
                      className="bg-red-500 text-white px-2 py-1 rounded text-xs"
                    >
                      Remover
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="5" className="border p-2">
                  <button
                    onClick={addParcela}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                  >
                    + Adicionar Parcela
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="mt-4 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
          >
            Confirmar Parcelas
          </button>
        </div>
      </div>
    </div>
  );
}

function ProdutoModal({ produtos, searchTerm, setSearchTerm, onSelect, onClose }) {
  const filtrados = produtos.filter(p =>
    p.nome?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.codigo?.includes(searchTerm) ||
    p.codigo_barras?.includes(searchTerm)
  );

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">Selecionar Produto</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <input
          type="text"
          placeholder="Buscar produto por nome, código ou código de barras..."
          className="w-full p-2 border rounded mb-4"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <div className="space-y-2 max-h-96 overflow-y-auto">
          {filtrados.map(produto => (
            <div
              key={produto.id}
              className="p-3 border rounded hover:bg-gray-50 cursor-pointer transition-colors"
              onClick={() => {
                onSelect(produto.id);
                onClose();
              }}
            >
              <div className="font-semibold">{produto.nome}</div>
              <div className="text-sm text-gray-600">
                Código: {produto.codigo} |
                Estoque: {produto.saldo_atual || 0} |
                Preço: R$ {produto.preco_custo?.toFixed(2) || '0,00'}
              </div>
            </div>
          ))}

          {filtrados.length === 0 && (
            <div className="text-center text-gray-500 py-4">
              Nenhum produto encontrado
            </div>
          )}
        </div>
      </div>
    </div>
  );
}